import { render, staticRenderFns } from "./viewMessages.vue?vue&type=template&id=5beb509d&scoped=true"
import script from "./viewMessages.vue?vue&type=script&lang=js"
export * from "./viewMessages.vue?vue&type=script&lang=js"
import style0 from "./viewMessages.vue?vue&type=style&index=0&id=5beb509d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beb509d",
  null
  
)

export default component.exports